/** VTTN supply figures (Voltron project PDF 2025-06-04) */
export const VTTN_TOTAL_SUPPLY = 1_000_000_000;
export const VTTN_CIRCULATING = 5_000_000;
export const VTTN_BURNED = 50_000_000;
export const VTTN_LOCKED = 945_000_000;
export const VTTN_HOLDERS = 12_944;
export const VTTN_PRICE_USD = 0.5;
